function returnDataTableTrainingResultsOptions(dataArray, filtersList, sortBy) {
    return {
        data: dataArray,
        order: [],
        columns: [
            {
                data: 'Image',
                render: function (data, type, row, meta) {
                    const layout = `
                            <img src="${data}" alt="" class="cardImageCell__img">
                            <span class="cardImageCell__favorite ${
                                row.Favorite === 'true' ? 'favorite' : ''
                            }"></span>`;
                    return layout;
                },
            },
            {
                data: 'Course',
            },
            {
                data: 'TOD',
                type: 'range',
            },
            {
                data: 'Date',
                type: 'date',
                render: function (data) {
                    let formattedDate = moment(data).format('ll');
                    return formattedDate;
                },
            },
            {
                data: 'Name',
            },
            { data: 'BIB' },

            { data: 'Time' },
            { data: 'Link' },
            { data: 'Favorite' },
        ],
        columnDefs: [
            {
                targets: 2,
                visible: true,
                searchable: true,
            },
            {
                target: 7,
                visible: false,
                searchable: true,
            },
            {
                target: 8,
                visible: false,
                searchable: true,
            },
        ],
        scrollX: true,
        fixedColumns: {
            leftColumns: 1,
        },
        search: {
            caseInsensitive: true,
        },
        // bDestroy - enable rerender table with new data array by event.
        bDestroy: true,
        pageLength: 15,
        layout: {
            top2Start: {
                rowClass: 'dt-filters-row',
                className: 'dt-filters-cell',
                features: function () {
                    let toolbar = `<div class="dt-filters-container">
                            <div class='dc js-dt-filters-container'></div>
                            <div class="btn-reset-all-desktop-wrapper hidden-flex js-dt-reset-all-cell">
                                <button type='button' class='btn-reset-all fz-12-16 fw-600 bg-c-transparent c-gray-6 c-dark-hover js-reset-all-btn'>
                                    <span>Reset all</span>
                                </button>
                            </div>
                        </div>
                        `;
                    return toolbar;
                },
            },
            top1Start: {
                rowClass: 'dt-filters-row-mobile',
                className: 'dt-filters-cell-mobile',
                features: function () {
                    let layout = `<div class="df fsc gap-16">
                            <button class='btn-filter' type='button' data-open='mdl-filters'>
                                <span>Filters</span>
                            </button>
                            <div class="hidden-block js-dt-reset-all-cell">
                                <button type='button' class='btn-reset-all fz-12-16 fw-600 bg-c-transparent c-gray-6 c-dark-hover js-reset-all-btn'>
                                    <span>Reset all</span>
                                </button>
                            </div>
                        </div>`;

                    return layout;
                },
            },
            topStart: {
                info: {
                    text: 'VIDEOS: _TOTAL_',
                    empty: 'VIDEOS: _TOTAL_',
                    search: '',
                },
            },
            topEnd: {
                rowClass: 'dt-results-row',
                className: 'dt-sort-by-cell-training',
                features: function () {
                    const sortByData = sortBy;

                    const layout = `<div class="table-sort-mobile js-table-sort-mobile-container">
                            <button class="table-sort-mobile__button c-gray js-sort-by-button" data-drop="sort-by-dropdown">
                                <span class="df">
                                    Sort by<span class="hidden-flex gap-8 js-sort-by-container">:<span class="fw-400 js-sort-by-text"></span></span>
                                </span>
                            </button>
                            <div id="sort-by-dropdown" class="table-sort-mobile__dropdown dropdown under left js-sort-by-dropdown js-dropdown">
                            ${sortByData
                                .map(
                                    (item) => `
                                    <button class="table-sort-mobile__option js-sort-by-mobile js-sort-by-mobile-${item.toLowerCase()}" type="button">
                                        <span class="js-sort-by-value">${item}</span>
                                        <span class="table-sort-mobile__order"></span>
                                    </button>
                                `
                                )
                                .join('')}
                            </div>
                        </div>`;
                    return layout;
                },
            },
            bottomStart: null,
            bottomEnd: {
                rowClass: 'dt-paging-row',
                className: 'dt-paging-cell',
                features: {
                    paging: {
                        type: 'simple_numbers',
                        buttons: 6,
                    },
                },
            },
        },
        createdRow: function (row, data, dataIndex) {
            $(row).each(function (index) {
                $(this)
                    .attr('data-href', data.Link)
                    .addClass('js-dt-row-clickable');
            });
        },
        initComplete: function () {
            // Add custom class to search input
            $('.dt-search').addClass('form-item-wrap form-item-wrap--search');

            const filtersContainer = $('.js-dt-filters-container');
            filtersContainer.empty();

            this.api()
                .columns(filtersList)
                .every(function (colIdx) {
                    let title = this.column(colIdx).title();
                    let column = this;

                    if (colIdx == 2) {
                        const timeValues = dataArray.map((item) =>
                            formatStringToMinutes(item.TOD)
                        );
                        const minTime = Math.min(...timeValues);
                        const maxTime = Math.max(...timeValues);
                        const maxTimeToDisplay =
                            maxTime + 60 > 1440 ? 1440 : maxTime + 60;

                        $(`<div class="form-item-wrap form-item-wrap--table-filter form-item-wrap--table-filter--range js-select-filter-wrap order${colIdx}">
                            <button type='button' class='btn-dropdown js-tod-filter-result-btn' data-drop-filter='tod-dropdown-range-filter'>
                                <span>TOD:</span>
                                <span class='js-tod-filter-result-text'>All</span>
                            </button>
                        </div>`).appendTo(filtersContainer);

                        $(`<div id='tod-dropdown-range-filter' class="dropdown dropdown--training-filter under right js-dropdown-filter">
                            <div class='df fse gap-12'>
                                <div class='df fdc gap-8 flex-1-0-0'>
                                    <div class='fz-15-26 c-gray-5'>From</div>
                                    <div class="form-item-wrap w-154">
                                        <input class='form-item unusable js-tod-min-field' type="text" readonly value='${formatTime(
                                            minTime
                                        )}'>
                                    </div>
                                </div>
                                <div class='mb-23 h-2 w-12 bg-c-gray-5 flex-shrink-0'></div>
                                <div class='df fdc gap-8 flex-1-0-0'>
                                    <div class='fz-15-26 c-gray-5'>To</div>
                                    <div class="form-item-wrap w-154">
                                        <input class='form-item unusable js-tod-max-field' type="text" readonly value='${formatTime(
                                            maxTimeToDisplay
                                        )}'>
                                    </div>
                                </div>
                            </div>
                            <div class="pt-23 pb-23">
                                <div class='js-tod-range-slider range-ui-slider'></div>
                            </div>
                        </div>`).appendTo(
                            $(`.js-select-filter-wrap.order${colIdx}`)
                        );

                        $('.js-tod-range-slider').slider({
                            range: true,
                            min: minTime,
                            max: maxTimeToDisplay,
                            values: [minTime, maxTimeToDisplay],
                            step: 1,
                            slide: function (event, ui) {
                                updateTimeRangeFieldsVisualFormat(
                                    ui.values[0],
                                    ui.values[1]
                                );
                                tableTrainingResults.draw();
                                isSliderAtEdge();
                            },
                            change: function (event, ui) {
                                updateTimeRangeFieldsVisualFormat(
                                    ui.values[0],
                                    ui.values[1]
                                );
                                tableTrainingResults.draw();
                            },
                        });
                    } else {
                        $(
                            `<div class="form-item-wrap form-item-wrap--no-border form-item-wrap--table-filter js-select-filter-wrap order${colIdx}"></div>`
                        ).appendTo(filtersContainer);
                        let selectBase = $(
                            `<select id="${colIdx}" class="js-select2-datatable" multiple data-placeholder="${title}: All"></select>`
                        )
                            .appendTo(
                                $(`.js-select-filter-wrap.order${colIdx}`)
                            )
                            .on('change', function () {
                                //Get the "text" property from each selected data
                                //regex escape the value and store in array
                                var data = $.map(
                                    $(this).select2('data'),
                                    function (value, key) {
                                        return value.text
                                            ? '^' +
                                                  $.fn.dataTable.util.escapeRegex(
                                                      value.text
                                                  ) +
                                                  '$'
                                            : null;
                                    }
                                );

                                //if no data selected use ""
                                if (data.length === 0) {
                                    data = [''];
                                }

                                //join array into string with regex or (|)
                                var val = data.join('|');

                                //search for the option(s) selected
                                column
                                    .search(val ? val : '', true, false)
                                    .draw();
                            });

                        let uniqueOptions = 0;

                        column
                            .data()
                            .unique()
                            .sort()
                            .each(function (d, j) {
                                uniqueOptions += 1;
                                const layout =
                                    '<option value="' +
                                    d +
                                    '">' +
                                    d +
                                    '</option>';
                                if (colIdx == 7) {
                                    selectBase.prepend(layout);
                                } else {
                                    selectBase.append(layout);
                                }
                            });

                        $.fn.select2.amd.require(
                            [
                                'select2/utils',
                                'select2/dropdown',
                                'select2/dropdown/attachContainer',
                                'select2/dropdown/search',
                                'select2/dropdown/attachBody',
                            ],
                            function (
                                Utils,
                                Dropdown,
                                DropdownSearch,
                                AttachBody,
                                DropdownAdapter,
                                AttachContainer
                            ) {
                                let $select = $(
                                    '.js-select2-datatable'
                                ).select2({
                                    closeOnSelect: false,
                                    width: '100%',
                                    minimumResultsForSearch: 5,
                                    dropdownAdapter: Utils.Decorate(
                                        Utils.Decorate(
                                            Dropdown,
                                            DropdownSearch
                                        ),
                                        AttachBody
                                    ),
                                });

                                $select.on('change', function (e) {
                                    var $selection = $(this)
                                        .closest('.js-select-filter-wrap')
                                        .find('.select2-selection__rendered');
                                    var count = $(this).val().length;
                                    var columnTitle = $($(this)[0])
                                        .attr('data-placeholder')
                                        .split(':')[0];

                                    if (count > 1) {
                                        $selection.html(
                                            `<span class="selected-options">${columnTitle}: (${count})</span>`
                                        );
                                    } else if (count === 1) {
                                        $selection.html(
                                            `<span class="selected-option">${columnTitle}: ${
                                                $(this).val()[0]
                                            }</span>`
                                        );
                                    } else {
                                        $selection.html(``);
                                    }

                                    setSelect2PlaceholderWidth();
                                });

                                setSelect2PlaceholderWidth();
                            }
                        );

                        if (uniqueOptions < 12) {
                            selectBase
                                .closest('.form-item-wrap')
                                .addClass('hide-search');
                        }
                    }
                });

            displayLargeDataTooltip();
            addCellLabel();
            setInfoResultsIntoMobileContainer(
                this.api().page.info().recordsDisplay
            );
            setResetAllControlsState();

            setTimeout(() => {
                $('.js-datatable-loader').removeClass('active');
                $('.js-datatable-wrap').addClass('active');

                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 0);
            }, 150);
        },
    };
}

function initTrainingResultsFunctionSet(results) {
    results.search.fixed('range', function (settings, data, dataIndex) {
        var min = formatStringToMinutes($('.js-tod-min-field').val());
        var max = formatStringToMinutes($('.js-tod-max-field').val());

        var todValue = formatStringToMinutes(data.TOD) || 0;

        if (
            (isNaN(min) && isNaN(max)) ||
            (isNaN(min) && todValue <= max) ||
            (min <= todValue && isNaN(max)) ||
            (min <= todValue && todValue <= max)
        ) {
            return true;
        }

        return false;
    });

    fireFunctionOnDataTablesNativeEvents(results);
    customSearch(results);

    /* HELPER FUNCTIONS */
    /* Reset all results */
    $(document).on('click', '.js-reset-all-btn', function () {
        resetAllResults();
        setTimeout(() => {
            results.draw();
        }, 0);
    });

    /* SORT BY MOBILE */
    $(document).on('click', '.js-sort-by-mobile-date', function () {
        setSortByOrder(results, 3, $(this));
    });
    $(document).on('click', '.js-sort-by-mobile-time', function () {
        setSortByOrder(results, 6, $(this));
    });

    /* /HELPER FUNCTIONS */
}
